import axios from 'axios';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import { mapResponseErrorToMessage } from '@hotjar/webapp/domains/common/api';

export interface ClientToken extends ApiBaseResponse {
  token: string;
}

export async function getClientToken(accountId: number): Promise<ClientToken> {
  const { data } = await axios.get<ClientToken>(`/api/v1/accounts/${accountId}/client-token`);

  if (!data.success) {
    throw new Error(mapResponseErrorToMessage(data.error));
  }

  return data;
}
